export default "__VITE_ASSET__D04OyW8l__"